import { render, staticRenderFns } from "./productDetailList.vue?vue&type=template&id=6076d9bb&scoped=true"
import script from "./productDetailList.vue?vue&type=script&lang=js"
export * from "./productDetailList.vue?vue&type=script&lang=js"
import style0 from "./productDetailList.vue?vue&type=style&index=0&id=6076d9bb&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6076d9bb",
  null
  
)

export default component.exports